import { Component, Inject } from "@angular/core";
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA, } from "@angular/material/dialog";
import { ApiService } from "app/api.service";
import { VoucherPostingComponent } from "app/voucher-posting/voucher-posting.component";

@Component({
  selector: "app-ledger-book-dialog",
  templateUrl: "./ledger-book-dialog.component.html",
  styleUrls: ["./ledger-book-dialog.component.scss"],
})
export class LedgerBookDialogComponent {
  voucherName: string;
  voucherNumber: string;
  date: string;
  narration: string;
  hostname: any;
  company_name: any;
  company_address: any;
  fullhostname: string;
  creation_voucher_id: any; 
  voucher_posting_id: any;

  constructor(
    private apiService: ApiService,
    private dialog: MatDialog,
    public dialogRef: MatDialogRef<LedgerBookDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.voucherName = data.voucher_name;
    this.voucherNumber = data.voucher_no;
    this.date = data.date;
    this.narration = data.narration;
    this.company_name = data.company_name;
    this.company_address = data.company_address;
    this.creation_voucher_id = data.creation_voucher_id;
    this.voucher_posting_id =data.voucher_posting_id;
  
  }

  ngOnInit() {
    this.hostname = window.location.hostname;
      this.fullhostname = window.location.origin;
  }
  closeModal() {
    this.dialogRef.close();
  }

  getTotalDebit(): number {
    return this.data.debits.reduce(
      (sum: number, entry: any) => sum + entry.amount,
      0
    );
  }

  getTotalCredit(): number {
    return this.data.credits.reduce(
      (sum: number, entry: any) => sum + entry.amount,
      0
    );
  }

  printModal() {
    const printContents = document.getElementById("print-section")?.innerHTML;
    const WindowPrt = window.open("", "", "width=900,height=700");

    if (WindowPrt && printContents) {
      WindowPrt.document.write(`
      <html>
        <head>
          <title>Print Voucher</title>
          <style>
            @media print {
              body {
                font-family: Arial, sans-serif;
                padding: 20px;
                margin: 0;
                color: #000;
                -webkit-print-color-adjust: exact;
                print-color-adjust: exact;
              }

              .modal-title {
                font-size: 22px;
                font-weight: bold;
                text-align: center;
                margin-bottom: 15px;
              }

              .company-details {
                text-align: center;
                margin-bottom: 10px;
              }

              .company-name {
                font-size: 18px;
                font-weight: bold;
              }

              .company-address {
                font-size: 14px;
                color: #666;
              }

              .voucher-info {
                text-align: center;
                margin-bottom: 15px;
              }

              .voucher-title {
                font-size: 20px;
                font-weight: bold;
              }

              .voucher-meta {
                font-size: 14px;
                color: #333;
              }

              .ledger-table {
                width: 100%;
                border-collapse: collapse;
              }

              .ledger-table th {
                background-color: #3f51b5 !important;
                color: white !important;
                padding: 12px;
                text-align: left;
                font-size: 14px;
                -webkit-print-color-adjust: exact;
                print-color-adjust: exact;
              }

              .ledger-table td {
                padding: 10px;
                font-size: 14px;
                color: #333;
                border-bottom: 1px solid #ddd;
              }

              .left-align {
                text-align: left;
                font-weight: bold;
              }

              .amount {
                text-align: right;
              }

              tfoot td {
                font-weight: bold;
                background-color: #f9f9f9;
                padding: 10px;
              }

              .narration-box {
                background-color: #f8f8f8;
                padding: 15px;
                margin-top: 15px;
                border-radius: 5px;
              }

              .narration-label {
                font-weight: bold;
                font-size: 14px;
                color: #333;
              }

              .narration-text {
                font-size: 14px;
                color: #666;
              }

              .modal-actions {
                display: none;
              }
            }
          </style>
        </head>
        <body onload="window.print(); window.close();">
          ${printContents}
        </body>
      </html>
    `);
      WindowPrt.document.close();
      WindowPrt.focus();
    }
  }

  goToPostedVoucherIndex() {
    // this.dialogRef.close();
    this.dialog.open(VoucherPostingComponent, {
      width: '95vw',
      height: '95vh',
      maxWidth: '100vw',
      data: {
        voucher_posting_id: this.voucher_posting_id
      }     
    });
  }

}
